import React from 'react';
import CabIndex from './CabIndex';
import {Link, useParams} from 'react-router-dom';

const DatacentreDetail = ({api, user}) => {
  let {dcId} = useParams();

  let dc = api.data.datacentres.find(d => parseInt(d.id) == dcId);

  if(!dc) {
    return <div className="alert alert-danger">Datacentre not found</div>
  }

  return <div>
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/">Datacentres</Link></li>
        <li className="breadcrumb-item active" aria-current="page">{dc.name}</li>
      </ol>
    </nav>
    <h3>{dc.name}</h3>
    <div className="list-group">{dc.cabs.map(c => <CabIndex key={"cab_" + c.id} cab={c} dcId={dc.id} user={user} api={api}></CabIndex>)}</div>
  </div>
}

export default DatacentreDetail;